import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchJSON, putJSON } from 'api/fetch';
import { captureException } from 'fe-core/util/errorTracking';

import { SLICE_NAME } from './constants';

export const fetchShift = createAsyncThunk('shifts/fetch', async (id: string) =>
  fetchJSON(`/schedule_builder/shifts/${id}`)
);

export const updateShift = createAsyncThunk(
  `${SLICE_NAME}/updateShift`,
  async (payload: any) => {
    try {
      if (payload.beforeDigestCallback) {
        payload.beforeDigestCallback();
      }

      const shiftData = payload?.payload || payload;
      const response = await putJSON(`/schedule_builder/shifts/${payload.id}`, {
        data: {
          type: 'shift',
          attributes: {
            startAt: shiftData.startAt,
            endAt: shiftData.endAt,
            color: shiftData.color,
            roleName: shiftData.roleName,
            note: shiftData.note,
          },
          relationships: {
            ...(shiftData.owner && {
              owner: {
                data: {
                  id: shiftData.owner?.id,
                  type: shiftData.owner?.type || 'job',
                },
              },
            }),
            ...(shiftData.role && {
              role: {
                data: {
                  id: shiftData.role?.id,
                  type: 'role',
                },
              },
            }),
          },
        },
      });
      return response;
    } catch (error) {
      captureException(error);
    }
  }
);
